<template>
  <div class="light-footer">
    <div class="clientDetail" v-if="clientData.length > 0">
      <img v-if="clientData[0].attributes.thumbnailUrl" :src="clientData[0].attributes.thumbnailUrl" :alt="clientData[0].attributes.initials" />
      <div v-else class="imgAlt"><span>{{ clientData[0].attributes.initials }}</span></div>
      <div class="stylist">
        <div>Your Stylist</div>
        <div class="stylistName">{{ clientData[0].attributes.name }}</div>
      </div>
    </div>
    <button
      class="btn btn-dark"
      :disabled="validated ? false : 'disabled'"
      @click="prchaseAction"
    >
    {{ buttonText }}
    <loading v-if = "buttonText === 'Updating'"></loading>
    </button>
  </div>
</template>

<script>
import loading from '../Loading'
export default {
  name: 'light-footer',
  props: ['buttonText', 'validated', 'clientData'],
  components: { loading },
  data () {
    return {}
  },
  methods: {
    prchaseAction () {
      this.$emit('prchaseAction')
    }
  },

  mounted () {}
}
</script>
